__turbopack_context__.v({
  "PhoneField": "phoneField-module__7S0UqW__PhoneField",
  "PhoneFieldError": "phoneField-module__7S0UqW__PhoneFieldError",
});
